'use es6';

import { List, Record } from 'immutable';
import { ContentTypes } from '../constants/ContentConstants';
export default Record({
  assetId: null,
  completed: null,
  content: null,
  contentType: ContentTypes.LINK,
  ctaCopy: null,
  displayOrder: null,
  graded: null,
  id: null,
  description: null,
  language: null,
  name: null,
  linkType: null,
  targetUrl: null,
  professors: List() // todo: remove once the API returns professors at root level

}, 'Link');